import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';

interface SectionProps {
  images: string[];
  titles: {
    mainTitle: string;
    subTitle: string;
    sectionTitle1: string;
    sectionTitle2: string;
    sectionTitle3: string;
    sectionTitle4: string;
  };
  descriptions: {
    sectionDescription1: string;
    sectionDescription2: string;
    sectionDescription3: string;
    imageAlt: string;
  };
  galleryLink: string;
  seo: {
    title: string;
    description: string;
  }
}

function SectionComponent ({images, titles, descriptions, galleryLink, seo}: SectionProps) {
  return (
    <main className="bg-white">
      <Helmet>
        <title>{seo.title} | MA Renovations</title>
        <meta name="description" content={seo.description} />
      </Helmet>

      <div className="pt-36 sm:pt-40 pb-6 px-6 max-w-5xl mx-auto">
        <h1 className="font-display text-3xl sm:text-4xl text-navy font-bold tracking-tight">{titles.mainTitle}</h1>
        <p className="mt-2 text-slate-500">{titles.subTitle}</p>
      </div>

      <section className="max-w-5xl mx-auto px-6 pb-16">
        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          <div className="aspect-[4/3] overflow-hidden rounded">
            <img className="w-full h-full object-cover" src={images[0]} alt={descriptions.imageAlt} />
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="text-xl font-display font-semibold text-navy mb-3">{titles.sectionTitle1}</h2>
            <p className="text-slate-600 leading-relaxed">{descriptions.sectionDescription1}</p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          <div className="flex flex-col justify-center order-2 lg:order-1">
            <h2 className="text-xl font-display font-semibold text-navy mb-3">{titles.sectionTitle2}</h2>
            <p className="text-slate-600 leading-relaxed">{descriptions.sectionDescription2}</p>
          </div>
          <div className="aspect-[4/3] overflow-hidden rounded order-1 lg:order-2">
            <img className="w-full h-full object-cover" src={images[1]} alt={descriptions.imageAlt} />
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          <div className="aspect-[4/3] overflow-hidden rounded">
            <img className="w-full h-full object-cover" src={images[2]} alt={descriptions.imageAlt} />
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="text-xl font-display font-semibold text-navy mb-3">{titles.sectionTitle3}</h2>
            <p className="text-slate-600 leading-relaxed">{descriptions.sectionDescription3}</p>
          </div>
        </div>

        <h2 className="text-2xl font-display font-semibold text-navy mb-6 text-center">{titles.sectionTitle4}</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {images.slice(0, 6).map((img, i) => (
            <div key={i} className="aspect-[4/3] overflow-hidden rounded">
              <img className="w-full h-full object-cover" src={img} alt={descriptions.imageAlt} />
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link to={galleryLink} onClick={() => {window.scrollTo({top: 0,})}}>
            <button className="px-10 py-3 bg-accent text-white rounded font-semibold hover:bg-accent-dark transition-colors" type="button">View projects</button>
          </Link>
        </div>
      </section>
    </main>
  )
}

export default SectionComponent;
